import React, {useState} from 'react';
import CustomLinesEllipsis from "../Mydata/CustomLinesEllipsis.js";
import user from "../../assets/img/userbig.png";
import moment from "moment";

import DeleteItem from "../DayOff/DeleteItem.js";
import {useNavigate} from "react-router-dom";

function SurveyItem({item}) {
    const [show, setShow] = useState(false)
    const [deleteId, setDelete] = useState(0)
    const isAllowed = item?.creator?.id === +localStorage.getItem('user_id')
    const navigate = useNavigate()

    return (
        <div className='recommendations-item card'>
            <div onClick={() => navigate(`/main_employee/surveys/${item.id}`)} className="recommendations-item-cont">
                <div className="card-overflow">
                    <div className="recommendations-item-top">
                        <div className='recommendations-item-heading'>
                            {item?.title}
                        </div>

                    </div>
                    <div className='recommendations-item-text'>
                        <CustomLinesEllipsis text={item?.purpose} maxLines={5}/>

                        <div className="process-file-message">
                            <div>{item?.status === "draft" ? "Դիտարկվում է" : item?.status === "active"?"Ակտիվ":"Ավարտված"}</div>
                            <div className="recommendations-item-text-icon-cont"/>
                        </div>
                        <div className="recommendations-item-text-icon-cont">

                            {(item?.attachments.length > 0) &&
                            <div className='recommendations-item-text-icon'>
                                <div className="add-file"><span className='icon-Attachment'/>
                                    <div
                                        className="tasks-around-cont">{item?.attachments.length || +item?.unseen_files_count > 0 ?
                                        <div
                                            className="tasks-around">{item?.attachments.length || +item?.unseen_files_count}</div> : null}
                                        </div>
                                </div>
                            </div>}
                            {item?.messages.length>0 &&
                            <div className='recommendations-item-text-icon'>
                                <div
                                    className="add-file">{(item?.messages.length || "") &&
                                <div
                                    className="tasks-around">{item?.messages.length || ''}</div>}{(item?.messages.length > 0) &&
                                <i className="far fa-envelope"/>}</div>
                            </div>}
                        </div>
                    </div>
                    <div className='recommendations-item-bottom'>
                        <hr/>
                        <div className='image-calendar'>
                            <div className="image-name-emplayee">
                                <img alt="img" className='task-image'
                                     src={item?.creator?.image || item?.manager?.image || user}/>
                                <span
                                    className="name-emplayee">{`${item?.creator?.first_name} ${item?.creator?.last_name}`}</span>
                            </div>
                            <span className='calendar'>
                            <span className='icon-Calendar'/>
                            <div className="task-date-cont">
                                <span
                                    className='moment'>Ստղ. {item?.created_at ? moment(item?.created_at).format('LLL') : null}</span>
                                <span
                                    className='moment'>Հարցման օր {item?.deadline ? moment(item?.deadline).format('LLL') : null}</span>
                                <span
                                    className='moment'>Հարցման ավարտ {item?.end_date ? moment(item?.end_date).format('LLL') : null}</span>
                            </div>
                        </span>
                        </div>


                    </div>

                </div>
            </div>

            {show && <div className='options'>
                {isAllowed ? (
                    <p className='options-item' onClick={() => setDelete(item.id)}>Ջնջել</p>
                ) : null}
            </div>}
            {isAllowed ? <span className="icon-Options" onClick={() => setShow(!show)}/> : null}
            {deleteId ? <DeleteItem open={deleteId} setOpen={setDelete} type={'survey'}/> : null}
        </div>
    );
}

export default SurveyItem;